module.exports = __webpack_public_path__ + "static/media/041.9fa10caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/041.jpg
// module id = 387
// module chunks = 0